"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _draftJs = require("draft-js");

var modifyBlockByKey = function modifyBlockByKey(editorState, blockKey, blockData) {
  var content = editorState.getCurrentContent();
  var blockMap = content.getBlockMap().map(function (b) {
    return b.key === blockKey ? b.merge(blockData) : b;
  });
  var newContent = content.merge({
    blockMap: blockMap
  });
  return _draftJs.EditorState.push(editorState, newContent, 'split-block' // TODO: will this do ?
  );
};

var _default = modifyBlockByKey;
exports["default"] = _default;